// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Persistence$Showside from "../utils/Persistence.bs.js";
import * as ProductSortOrder2$Showside from "../utils/ProductSortOrder2.bs.js";
function useSorts(appliedSort, categoryDefaultSort, availableSorts, connection) {
  var connectionDefaultSort = Belt_Option.map(connection, function (connection) {
    return connection.sortBy;
  });
  var replaceDefaultWith = Belt_Option.flatMap(categoryDefaultSort, function (defaultSortOrder) {
    if (Caml_obj.equal(connectionDefaultSort, /* Default */0) && Belt_Option.mapWithDefault(availableSorts, false, function (sorts) {
      return sorts.includes(defaultSortOrder);
    })) {
      return defaultSortOrder;
    }
  });
  var availableSorts$1 = Belt_Option.map(availableSorts, function (sorts) {
    return Belt_Array.keepMap(sorts, function (sort) {
      if (Caml_obj.equal(sort, replaceDefaultWith)) {
        return;
      } else if (sort === /* Default */0 && Belt_Option.isSome(replaceDefaultWith)) {
        return Belt_Option.flatMap(replaceDefaultWith, function (sub) {
          return [ProductSortOrder2$Showside.humanizeSort(sub), /* Default */0];
        });
      } else {
        return [ProductSortOrder2$Showside.humanizeSort(sort), sort];
      }
    });
  });
  var effectiveSort = appliedSort !== undefined ? appliedSort : connectionDefaultSort !== undefined ? connectionDefaultSort : categoryDefaultSort !== undefined ? categoryDefaultSort : undefined;
  var availableSorts$2 = Persistence$Showside.use(availableSorts$1);
  var effectiveSort$1 = Persistence$Showside.use(effectiveSort);
  return [effectiveSort$1, Belt_Option.getWithDefault(availableSorts$2, [])];
}
export { useSorts };
/* Persistence-Showside Not a pure module */